import React from 'react';
import { withStyles, createStyles } from '@material-ui/core';
import Grid from '../Grid';
import { Typography } from '../Typography';
var styles = createStyles({
    formSectionWithTitle: {
        margin: '30px auto',
        maxWidth: '100%',
    },
    formSectionWithoutTitle: {
        margin: 'auto',
        maxWidth: '100%',
    },
});
export var FormSection = function (_a) {
    var title = _a.title, classes = _a.classes, children = _a.children, subTitle = _a.subTitle, direction = _a.direction;
    return (React.createElement(Grid, { container: true, spacing: 4, direction: direction || 'column', className: title ? classes.formSectionWithTitle : classes.formSectionWithoutTitle },
        title || subTitle ? (React.createElement(Grid, { item: true },
            title && React.createElement(Typography.H2, null, title),
            subTitle && (React.createElement(Typography.Caption, { color: "muted" }, subTitle)))) : null,
        children));
};
export default withStyles(styles)(FormSection);
//# sourceMappingURL=FormSection.js.map